function voicePrompt (text){
    new Audio('https://tsn.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=' + encodeURIComponent(text)).play();
}
export {
    voicePrompt
}